'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require('reactackle-core');

var _reactackleButton = require('reactackle-button');

var _styles = require('./styles');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

var buttonAdditionalProps = {
  /**
   * Close alert on button click
   */
  closeAlert: _propTypes2.default.bool,

  /**
   * Specify Button component. We use Reactackle Button as a default.
   */
  buttonComponent: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func])
};
var propTypes = {
  /**
   * Alert item id
   */
  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  /**
   * Changes Alert layout direction to vertical (buttons will be placed under
   * Alert content)
   */
  vertical: _propTypes2.default.bool,

  /**
   * Alert color scheme
   */
  colorScheme: _propTypes2.default.oneOf(['default', 'warning', 'error', 'success', 'info']),

  /**
   * Array of Alert's buttons
   */
  buttons: _propTypes2.default.arrayOf(_propTypes2.default.shape.apply(_propTypes2.default, [_reactackleButton.Button.propTypes].concat(_toConsumableArray(buttonAdditionalProps)))),

  /**
   * Function to be called on Close button click
   */
  onClose: _propTypes2.default.func,

  /**
   * Speed of exit animation
   */
  closeAnimation: _propTypes2.default.bool
};
var defaultProps = {
  id: '',
  colorScheme: 'default',
  vertical: false,
  buttons: [],
  onClose: _reactackleCore.noop,
  closeAnimation: false
};

var Alert = function (_Component) {
  _inherits(Alert, _Component);

  function Alert(props) {
    _classCallCheck(this, Alert);

    var _this = _possibleConstructorReturn(this, (Alert.__proto__ || Object.getPrototypeOf(Alert)).call(this, props));

    _this._handleClose = _this._handleClose.bind(_this);
    return _this;
  }

  _createClass(Alert, [{
    key: '_handleClose',
    value: function _handleClose() {
      this.props.onClose(this.props.id);
    }
  }, {
    key: '_renderButtonsArea',
    value: function _renderButtonsArea() {
      var _this2 = this;

      if (this.props.buttons && this.props.buttons.length) {
        var buttons = this.props.buttons.map(function (button, index) {
          var pressHandler = function pressHandler() {
            if (button.action) button.action();
            if (button.closeAlert) _this2._handleClose();
          };

          if (button.buttonComponent) {
            var buttonElement = void 0;

            if (typeof button.buttonComponent === "function") {
              var _Button = button.buttonComponent;
              buttonElement = _react2.default.createElement(_Button, {
                key: (0, _reactackleCore.getKey)(button, index)
              });
            } else {
              buttonElement = _react2.default.cloneElement(button.buttonComponent, {
                key: (0, _reactackleCore.getKey)(button, index)
              });
            }

            return buttonElement;
          }

          return _react2.default.createElement(_reactackleButton.Button, _extends({}, button, {
            onPress: pressHandler,
            key: (0, _reactackleCore.getKey)(button, index)
          }));
        });
        return _react2.default.createElement(_styles.ActionsStyled, null, _react2.default.createElement(_styles.ActionsWrapperStyled, null, buttons));
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var buttonsArea = this._renderButtonsArea();

      return _react2.default.createElement(_styles.AlertStyled, {
        vertical: this.props.vertical,
        colorScheme: this.props.colorScheme,
        animateExit: this.props.closeAnimation,
        role: 'alert'
      }, _react2.default.createElement(_styles.ContentStyled, null, this.props.children), buttonsArea);
    }
  }]);

  return Alert;
}(_react.Component);

exports.default = Alert;
Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;
Alert.displayName = 'Alert';